import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarDismiss } from '@angular/material/snack-bar';
import { ToastMessageInterface } from '@core/interfaces/toast-message.interface';
import { concatMap, Observable, of, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ToastService {
    private queueSubject = new Subject<ToastMessageInterface>();

    constructor(private snackBar: MatSnackBar) {
        this.initShowingFromQueue();
    }

    private initShowingFromQueue() {
        this.queueSubject
            .pipe(concatMap((toastItem) => this.showToast(toastItem)))
            .subscribe();
    }

    private set putInQueue(toast: ToastMessageInterface) {
        this.queueSubject.next(toast);
    }

    openSuccess(message: string, action?: string, optionsData?: any) {
        const options = optionsData || {
            verticalPosition: 'top',
            panelClass: ['success-toast'],
            duration: 3000,
        };
        this.putInQueue = { message, action, options };
    }

    openWarning(message: string, action?: string, optionsData?: any) {
        const options = optionsData || {
            verticalPosition: 'top',
            panelClass: ['warning-toast'],
            duration: 3000,
        };
        this.putInQueue = { message, action, options };
    }

    openError(message: string, action?: string, optionsData?: any) {
        const options = optionsData || {
            verticalPosition: 'top',
            panelClass: ['error-toast'],
            duration: 3000,
        };
        this.putInQueue = { message, action, options };
    }

    private showToast(
        value: ToastMessageInterface | undefined
    ): Observable<MatSnackBarDismiss | null> {
        if (!value) {
            return of(null);
        }
        const action = value.action || '';
        return this.snackBar
            .open(value.message, action, value.options)
            .afterDismissed();
    }
}
